import React from "react";
import { Row, Container, Col } from "react-bootstrap";
import {
  UkUniqueNum,
  UkUniqueNumTwo,
  UkUniqueNumThree,
  UkUniqueNumFour,
} from "../../../../app-constants";
import { Link } from "gatsby";

function Techsolution(props) {
  return (
    <div className="techsolution tech_uk tech_uk_new tech_music_solution  p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={10}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <h2>Our Mobile App Development Prowess</h2>
            <p>
              Our app development USP lies in our advanced integration of novel
              technologies and data analytics. We use predictive analytics and
              robust development frameworks to build high-performance, scalable
              applications. Our custom solutions are designed to optimise user
              engagement and deliver precise, data-driven results tailored to
              your business needs.
            </p>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="">
            <div className="solution_box">
              <div className="solution_box_items">
                <div className="item_icon">{UkUniqueNum}</div>
                <div className="item_txt">
                  <h5>Top UK App Developers</h5>
                  <p>
                    Our expert team delivers tailored app solutions with deep
                    technical expertise.
                  </p>
                </div>
              </div>
              <div className="solution_box_items">
                <div className="item_icon">{UkUniqueNumTwo}</div>
                <div className="item_txt">
                  <h5>24/7 Availability</h5>
                  <p>
                    We provide round-the-clock support to ensure your app's
                    uninterrupted performance.
                  </p>
                </div>
              </div>
              <div className="solution_box_items">
                <div className="item_icon">{UkUniqueNumThree}</div>
                <div className="item_txt">
                  <h5>Fast Turnaround </h5>
                  <p>
                    Efficient processes and a dedicated team ensure rapid
                    delivery of high-quality apps.
                  </p>
                </div>
              </div>
              <div className="solution_box_items">
                <div className="item_icon">{UkUniqueNumFour}</div>
                <div className="item_txt">
                  <h5>Customisable Solutions</h5>
                  <p>
                    Our apps are designed to adapt to evolving business needs,
                    app marketplaces, and user demands.
                  </p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="m-auto text-center"
          >
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Schedule Consultation
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Techsolution;
